import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  pill: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 10px',
    borderRadius: 12,
    // The design tints the container and its border faintly toward the Labra AI
    // gradient rather than using a neutral grey.
    border: `1px solid ${alpha(theme.palette.labraAIGradient.end, 0.1)}`,
    background: `linear-gradient(100deg, ${alpha(
      theme.palette.labraAIGradient.start,
      0.05
    )}, ${alpha(theme.palette.labraAIGradient.end, 0.05)})`,
  },
  iconTile: {
    width: 30,
    height: 30,
    borderRadius: 8,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, ${alpha(
      theme.palette.labraAIGradient.start,
      0.16
    )}, ${alpha(theme.palette.labraAIGradient.end, 0.14)})`,
  },
  icon: {
    fontSize: 15,
    // `middle` (#BF548E) is the magenta in the gradient; `aiBadgeGradient.pink`
    // (#FF7488) reads coral and misses the design.
    color: theme.palette.labraAIGradient.middle,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    // Both are needed for the title's ellipsis to kick in inside a flex row.
    minWidth: 0,
    flex: 1,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    fontSize: 11,
    lineHeight: '15px',
    color: theme.palette.grey[600],
  },
  dismiss: {
    width: 24,
    height: 24,
    flexShrink: 0,
    padding: 0,
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.labraChat.hoverBgAlt,
    color: theme.palette.grey[600],
    '&:hover': {
      backgroundColor: theme.palette.labraChat.borderStrong,
    },
  },
  dismissIcon: {
    fontSize: 11,
  },
}))
